import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class MeSicAssignmentService {

  constructor(private http: HttpClient) { }

  /**
   * Save Parent ME SIC Code Assignment
   * Action code: 6ffgmj
   * Following AngularJS SysSettingsFactory.saveParentMe pattern
   */
  saveParentMe(
    baseUrl: string,
    saveData: any,
    globalService: any,
    filterParams: any,
    rowData: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=6ffgmj`;

    // Build AngularJS-compatible payload structure
    // Following AngularJS: params = _.merge({}, GlobalService.globalParams, params);
    let params: any = _.merge({}, globalService || {}, filterParams);

    // Build clob_data and clob_settings from saveData.data array
    // Following AngularJS: JSON.stringify(request.data) for both
    const jsonObj = JSON.stringify(saveData.data || []);
    const jsonSettings = JSON.stringify(saveData.data || []);

    // 🔴 CRITICAL: Include ALL required parameters with proper fallback chains for action code 6ffgmj
    // Matching exact payload structure
    params.clob_settings = jsonSettings;
    params.clob_data = jsonObj;
    params.tax_year = saveData.tax_year || filterParams?.tax_year || globalService?.tax_year || globalService?.globalParams?.tax_year || rowData?.TAX_YEAR || '2024';
    params.screen_key = filterParams?.screen_key || globalService?.screen_key || globalService?.globalParams?.screen_key || rowData?.SCREEN_KEY || '376';
    params.scenario = filterParams?.scenario || globalService?.scenario || globalService?.globalParams?.scenario || rowData?.SCENARIO || '74';
    params.jcd_key = filterParams?.jcd_key || globalService?.jcd_key || globalService?.globalParams?.jcd_key || rowData?.JCD_KEY || '250';
    params.jcd_ta_key = filterParams?.jcd_ta_key || globalService?.jcd_ta_key || globalService?.globalParams?.jcd_ta_key || rowData?.JCD_TA_KEY || '1250';
    params.activity_key = filterParams?.activity_key || globalService?.activity_key || globalService?.globalParams?.activity_key || rowData?.ACTIVITY_KEY || '1349';
    params.screen_type = filterParams?.screen_type || globalService?.screen_type || globalService?.globalParams?.screen_type || rowData?.SCREEN_TYPE || 'grid';
    params.is_locked = filterParams?.is_locked || globalService?.is_locked || globalService?.globalParams?.is_locked || rowData?.IS_LOCKED || 'N';
    params.issue_id = filterParams?.issue_id || globalService?.issue_id || globalService?.globalParams?.issue_id || rowData?.ISSUE_ID || '';
    params.issue_short_desc = filterParams?.issue_short_desc || globalService?.issue_short_desc || globalService?.globalParams?.issue_short_desc || rowData?.ISSUE_SHORT_DESC || '';
    params.issue_id_for_tx_save = filterParams?.issue_id_for_tx_save || globalService?.issue_id_for_tx_save || globalService?.globalParams?.issue_id_for_tx_save || rowData?.ISSUE_ID_FOR_TX_SAVE || '';
    params.scenarioCode = filterParams?.scenarioCode || filterParams?.scenario_code || globalService?.scenarioCode || globalService?.scenario_code || globalService?.globalParams?.scenarioCode || globalService?.globalParams?.scenario_code || 'RAF';
    params.is_issue_key_enabled = filterParams?.is_issue_key_enabled || globalService?.is_issue_key_enabled || globalService?.globalParams?.is_issue_key_enabled || rowData?.IS_ISSUE_KEY_ENABLED || 'N';

    // 🔴 CRITICAL: Use application/x-www-form-urlencoded (NOT application/json)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: true
    };

    return this.http.post<any>(url, urlEncoded.toString(), httpOptions);
  }
}
